import { render, staticRenderFns } from "./ChangeProfile.vue?vue&type=template&id=73bc7984&scoped=true"
import script from "./ChangeProfile.vue?vue&type=script&lang=js"
export * from "./ChangeProfile.vue?vue&type=script&lang=js"
import style0 from "./ChangeProfile.vue?vue&type=style&index=0&id=73bc7984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bc7984",
  null
  
)

export default component.exports